export default "__VITE_ASSET__e94996d2__"